import React, { useState } from "react";

const FileUpload = ({ setUploadedFiles, onClose }) => {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e) => {
    setFiles([...e.target.files]);
  };

  const handleUpload = () => {
    setUploading(true);

    console.log(files);

    // Simulate file upload
    setTimeout(() => {
      setUploadedFiles((prev) => [...prev, ...files]);
      setFiles([]);
      setUploading(false);
      onClose(); // Close the modal after upload
    }, 2000);
  };

  return (
    <div className="max-w-md p-6 mx-auto mt-10 border rounded-lg shadow-lg">
      <h2 className="mb-4 text-2xl font-bold text-center">Upload</h2>
      <div className="p-6 text-center border-2 border-green-500 border-dashed rounded-lg">
        <input
          type="file"
          multiple
          onChange={handleFileChange}
          className="hidden"
          id="fileInput"
        />

        <label
          htmlFor="fileInput"
          className="block text-green-600 cursor-pointer"
        >
          <div className="flex flex-col items-center justify-center">
            <div className="mb-2 text-3xl">📂</div>
            <div className="text-lg font-medium">
              Drag & drop files or <span className="underline">Browse</span>
            </div>
            <div className="mt-1 text-sm text-gray-500">
              Supported format: PDF
            </div>
          </div>
        </label>
      </div>

      <button
        onClick={handleUpload}
        className="w-full py-2 mt-6 text-white transition bg-green-600 rounded-lg hover:bg-green-700"
        disabled={!files.length}
      >
        {uploading ? "Uploading..." : "Upload Files"}
      </button>

      {uploading && (
        <div className="mt-4 text-center">
          <p>
            Uploading - {files.length} {files.length === 1 ? "file" : "files"}
          </p>
          <div className="relative pt-1">
            <div className="flex items-center justify-between mb-2">
              <div className="text-right">
                <span className="inline-block text-xs font-semibold text-green-600">
                  Progress
                </span>
              </div>
            </div>
            <div className="flex h-2 mb-4 overflow-hidden text-xs bg-green-200 rounded">
              <div
                style={{ width: "100%" }}
                className="flex flex-col justify-center text-center text-white bg-green-500 shadow-none whitespace-nowrap"
              ></div>
            </div>
          </div>
        </div>
      )}

      {files.length > 0 && (
        <div className="mt-6">
          <h3 className="mb-2 text-xl font-bold">Files to Upload</h3>
          {files.map((file, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-2 mb-2 bg-yellow-100 border rounded-lg"
            >
              <span>{file.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FileUpload;
